import * as React from "react";
import clsx from "clsx";

interface Props {
  status: "NEW" | "FAILED" | "COMPLETED" | "IN_PROGRESS";
}

export const ChronologyListRowStatus: React.FC<Props> = ({ status }) => (
  <span
    className={clsx("inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset", {
      "bg-gray-50 text-gray-600 ring-gray-500/10": status === "NEW",
      "bg-red-50 text-red-700 ring-red-600/10": status === "FAILED",
      "bg-green-50 text-green-700 ring-green-600/20": status === "COMPLETED",
      "bg-indigo-50text-indigo-700 ring-indigo-700/10": status === "IN_PROGRESS",
    })}
  >
    {status.replace("_", " ").toLowerCase()}
  </span>
);
